<template>
  <div class="h-auto p-4 dark:bg-gray-800">
    <div class="w-full  pt-12" :style="{ height: containerHeight }">
      <div id="logo" class="mb-12 flex justify-center items-center">
        <img src="/assets/img/BatchflowLogo.svg" alt="bf">
      </div>
      <slot name="header"/>
      <div class="mb-6 text-center">
        <h1 class="text-3xl font-medium">{{ title }}</h1>
        <p class="text-sm mx-5 text-paper-black font-normal" v-html="subtitle"/>
      </div>
      <slot/>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useEventStore} from "~/store/useEvents";
defineProps({
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    required: true
  }
});
const storeEvent = useEventStore();
const containerHeight = computed(() => storeEvent.resetPasswordKeyboardOpen ? 'calc(100dvh + 270px)' : '100dvh')
</script>